package com.daytimegaming.ourdailyfinances.presentation.auth

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.daytimegaming.ourdailyfinances.domain.repository.UserRepository
import com.daytimegaming.ourdailyfinances.domain.usecase.AuthUseCase
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch

class LoginViewModel(
    private val authUseCase: AuthUseCase,
    private val userRepository: UserRepository,
) : ViewModel() {

    private val _state = MutableStateFlow<AuthScreenState>(AuthScreenState.Idle)
    val state = _state.asStateFlow()

    fun login(email: String, password: String) {
        viewModelScope.launch {
            _state.update { AuthScreenState.Loading }
            try {
                authUseCase.LoginUser(email, password)
                userRepository.getProfile()
                _state.update { AuthScreenState.Idle }
            } catch (e: Exception) {
                try { authUseCase.SignOutUser() } catch (_: Exception) {}
                _state.update {
                    AuthScreenState.Error(
                        formatAuthErrorMessage(
                            e.message,
                            defaultMessage = "Invalid Username or Password"
                        )
                    )
                }
            }
        }
    }

    fun clearError() {
        _state.update { AuthScreenState.Idle }
    }
}
